import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

const newsheaders = {
		"accept-language": "en",
		"x-bingapis-sdk": "true",
		"x-rapidapi-host": "bing-news-search1.p.rapidapi.com",
		"x-rapidapi-key": "9120775ad6mshb7baaa0bf6d1e0ap1ad137jsn5a8a10cbb3f8",
		"useQueryString": true
  }


const baseUrl = 'https://bing-news-search1.p.rapidapi.com/'

const createRequest = (url) => ({url, headers: newsheaders})


export const newsApi = createApi({
    reducerPath: 'newsApi',
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder)=>({
        getNews: builder.query({
            query: ({category,count})=> createRequest(`/news/search?q=${category}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`)
        })
    })
})


export const {
    useGetNewsQuery,
} =  newsApi